var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"change-goal goal-button-toggle",on:{"click":_vm.openCloseWindow}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v("Change my goals "),_c('i',{staticClass:"fa fa-arrow-circle-o-up"})])
}]

export { render, staticRenderFns }